'use client';

import {useContext} from 'react';

import {Badge, BadgeVariant} from 'Badge';

import {TabsInnerContext} from '../Tabs';

import type {TabProps} from '../types';

export const TabBadge: React.FC<Pick<TabProps, 'value' | 'badge' | 'disabled'>> = ({value, badge, disabled}) => {
  const curValue = useContext(TabsInnerContext).value;

  if (!badge) {
    return null;
  }

  let variant = curValue === value ? BadgeVariant.Accent : BadgeVariant.Grey;

  if (disabled) {
    variant = BadgeVariant.Disabled;
  }

  return (
    <Badge data-badge variant={variant}>
      {badge}
    </Badge>
  );
};
